import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { jwtDecode } from "jwt-decode";
import { IUser } from "../models/user";
import { UserRole, isUserRole, resolveRole } from "../services/roles";

interface RoleGuardProps {
  roles: UserRole[];
  children: React.ReactNode;
}

const getRole = (
  user: IUser | undefined,
  accessToken: string | null
): UserRole => {
  if (user?.role) {
    return resolveRole(user.role);
  }
  if (accessToken) {
    try {
      const decoded: any = jwtDecode(accessToken);
      return resolveRole(decoded?.role);
    } catch {
      /* ignore */
    }
  }
  return "admin";
};

const RoleGuard = ({ roles, children }: RoleGuardProps) => {
  const user = useSelector(({ UserSlice }: any) => UserSlice.user as IUser);
  const accessToken = useSelector(
    ({ UserSlice }: any) => UserSlice.accessToken as string | null
  );
  const role = getRole(user, accessToken);

  if (!roles.includes(role)) {
    return (
      <Navigate to={isUserRole(role) ? "/devices" : "/main"} replace />
    );
  }

  return <>{children}</>;
};

export default RoleGuard;
